import { render, staticRenderFns } from "./PagePlan.vue?vue&type=template&id=72a5de08&"
import script from "./PagePlan.vue?vue&type=script&lang=ts&"
export * from "./PagePlan.vue?vue&type=script&lang=ts&"
import style0 from "./PagePlan.vue?vue&type=style&index=0&id=72a5de08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports